import { DetailsSection } from './DetailsSection'
import { KeyContactsSection } from './KeyContactsSection'

import { styled } from 'lib/styled'

const Container = styled.section()

function CompanyDetailsForm({ id, isEditing, isActive, ...props }) {
  return (
    <Container {...props}>
      <DetailsSection isEditing={isEditing} />

      <KeyContactsSection isEditing={isEditing} />
    </Container>
  )
}

export { CompanyDetailsForm }
